import axios from 'axios';

export const getList = params => axios.post('/business/customerRideCard/list', params).then(res => res ? res.data : {
    code: 500,
    message: '服务器无法连接,请稍后重试'
});
